import RequestDestructionComponent from '@inter-ikea-storagetwo/range/dist/components/RequestDestructionComponent';
export const removeSection = (entity) => entity.addComponent(new RequestDestructionComponent());
//# sourceMappingURL=removeSection.js.map